var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMloSearchLady(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1216,
    height: 364,
    viewBox: "0 0 1216 364",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    width: 1207,
    height: 363,
    fill: "#31B9B5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M478.453 95.5762C476.051 89.9633 469.983 79.4835 457.443 76.6139C445.964 73.9971 437.305 88.4969 430.188 89.5588C423.071 90.6207 423.867 87.4224 409.645 82.0877C397.484 77.5241 389.318 89.3945 386.436 95.5762H478.453Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M200.021 72.4801C200.021 72.4801 200.021 59.7121 187.481 59.1812C181.488 58.9284 174.169 63.8333 169.542 56.0714C164.17 47.058 154.764 41.6853 146.307 45.1744C136.965 49.0301 131.668 63.7953 122.541 62.5944C113.414 61.3808 96.0066 55.3129 87.0059 72.4927H200.021V72.4801Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M415.381 363.526V199.262H408.542L396.81 178.934L386.318 160.781V127.243H383.828V160.781L373.348 178.934L361.616 199.262H354.777V363.526H415.381Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M141.211 363.526V199.262H134.372L122.64 178.934L112.161 160.781V127.243H109.67V160.781L99.1778 178.934L87.4465 199.262H80.6074V363.526H141.211Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M336.917 185.04H277.957V363.526H336.917V185.04Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M568.433 165.408H498.879V363.538H568.433V165.408Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3057 157.494H62.2402V363.538H89.3057V157.494Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M233.648 363.526V188.39L164.082 216.973V363.526H233.648Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M501.472 363.526V157.166H494.177V141.945L488.805 139.505V98.6228H486.226V138.342L436.014 115.588V157.166H431.008V363.526H501.472Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M285.615 199.262H225.012V363.525H285.615V199.262Z",
    fill: "#E6E6E6",
    fillOpacity: 0.3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M241.259 209.312H231.854V213.723H241.259V209.312Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M260.03 209.312H250.625V213.723H260.03V209.312Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M278.79 209.312H269.385V213.723H278.79V209.312Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M241.259 220.221H231.854V224.633H241.259V220.221Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M260.03 220.221H250.625V224.633H260.03V220.221Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M278.79 220.221H269.385V224.633H278.79V220.221Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M241.259 231.131H231.854V235.543H241.259V231.131Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M260.03 231.131H250.625V235.543H260.03V231.131Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M278.79 231.131H269.385V235.543H278.79V231.131Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M241.259 242.053H231.854V246.465H241.259V242.053Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M260.03 242.053H250.625V246.465H260.03V242.053Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M278.79 242.053H269.385V246.465H278.79V242.053Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M241.259 252.963H231.854V257.375H241.259V252.963Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M260.03 252.963H250.625V257.375H260.03V252.963Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M278.79 252.963H269.385V257.375H278.79V252.963Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M241.259 263.872H231.854V268.284H241.259V263.872Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M260.03 263.872H250.625V268.284H260.03V263.872Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M278.79 263.872H269.385V268.284H278.79V263.872Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M241.259 274.795H231.854V279.207H241.259V274.795Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M260.03 274.795H250.625V279.207H260.03V274.795Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M278.79 274.795H269.385V279.207H278.79V274.795Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M241.259 285.704H231.854V290.116H241.259V285.704Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M260.03 285.704H250.625V290.116H260.03V285.704Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M278.79 285.704H269.385V290.116H278.79V285.704Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M241.259 296.626H231.854V301.038H241.259V296.626Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M260.03 296.626H250.625V301.038H260.03V296.626Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M278.79 296.626H269.385V301.038H278.79V296.626Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M241.259 307.536H231.854V311.948H241.259V307.536Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M260.03 307.536H250.625V311.948H260.03V307.536Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M278.79 307.536H269.385V311.948H278.79V307.536Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M241.259 318.446H231.854V322.857H241.259V318.446Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M260.03 318.446H250.625V322.857H260.03V318.446Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M278.79 318.446H269.385V322.857H278.79V318.446Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M241.259 329.368H231.854V333.78H241.259V329.368Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M260.03 329.368H250.625V333.78H260.03V329.368Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M278.79 329.368H269.385V333.78H278.79V329.368Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M122.842 199.262H62.2383V363.525H122.842V199.262Z",
    fill: "#E6E6E6",
    fillOpacity: 0.3
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4854 209.312H69.0801V213.723H78.4854V209.312Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2451 209.312H87.8398V213.723H97.2451V209.312Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M116.017 209.312H106.611V213.723H116.017V209.312Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4854 220.221H69.0801V224.633H78.4854V220.221Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2451 220.221H87.8398V224.633H97.2451V220.221Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M116.017 220.221H106.611V224.633H116.017V220.221Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4854 231.131H69.0801V235.543H78.4854V231.131Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2451 231.131H87.8398V235.543H97.2451V231.131Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M116.017 231.131H106.611V235.543H116.017V231.131Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4854 242.053H69.0801V246.465H78.4854V242.053Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2451 242.053H87.8398V246.465H97.2451V242.053Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M116.017 242.053H106.611V246.465H116.017V242.053Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4854 252.963H69.0801V257.375H78.4854V252.963Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2451 252.963H87.8398V257.375H97.2451V252.963Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M116.017 252.963H106.611V257.375H116.017V252.963Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4854 263.872H69.0801V268.284H78.4854V263.872Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2451 263.872H87.8398V268.284H97.2451V263.872Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M116.017 263.872H106.611V268.284H116.017V263.872Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4854 274.795H69.0801V279.207H78.4854V274.795Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2451 274.795H87.8398V279.207H97.2451V274.795Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M116.017 274.795H106.611V279.207H116.017V274.795Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4854 285.704H69.0801V290.116H78.4854V285.704Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2451 285.704H87.8398V290.116H97.2451V285.704Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M116.017 285.704H106.611V290.116H116.017V285.704Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4854 296.626H69.0801V301.038H78.4854V296.626Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2451 296.626H87.8398V301.038H97.2451V296.626Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M116.017 296.626H106.611V301.038H116.017V296.626Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4854 307.536H69.0801V311.948H78.4854V307.536Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2451 307.536H87.8398V311.948H97.2451V307.536Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M116.017 307.536H106.611V311.948H116.017V307.536Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4854 318.446H69.0801V322.857H78.4854V318.446Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2451 318.446H87.8398V322.857H97.2451V318.446Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M116.017 318.446H106.611V322.857H116.017V318.446Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4854 329.368H69.0801V333.78H78.4854V329.368Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2451 329.368H87.8398V333.78H97.2451V329.368Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M116.017 329.368H106.611V333.78H116.017V329.368Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M255.316 199.262H231.854L243.585 178.934L255.316 158.619L267.047 178.934L278.779 199.262H255.316Z",
    fill: "#E6E6E6",
    fillOpacity: 0.3
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M256.567 127.243H254.076V173.562H256.567V127.243Z",
    fill: "#E6E6E6",
    fillOpacity: 0.3
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M352.627 108.723H350.137V155.042H352.627V108.723Z",
    fill: "#E6E6E6",
    fillOpacity: 0.3
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M364.803 165.054H296.994V363.525H364.803V165.054Z",
    fill: "#E6E6E6",
    fillOpacity: 0.3
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M316.837 177.48H307.432V181.892H316.837V177.48Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M335.597 177.48H326.191V181.892H335.597V177.48Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M354.356 177.48H344.951V181.892H354.356V177.48Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M316.837 188.39H307.432V192.802H316.837V188.39Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M335.597 188.39H326.191V192.802H335.597V188.39Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M354.356 188.39H344.951V192.802H354.356V188.39Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M316.837 199.3H307.432V203.711H316.837V199.3Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M335.597 199.3H326.191V203.711H335.597V199.3Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M354.356 199.3H344.951V203.711H354.356V199.3Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M316.837 210.222H307.432V214.634H316.837V210.222Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M335.597 210.222H326.191V214.634H335.597V210.222Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M354.356 210.222H344.951V214.634H354.356V210.222Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M316.837 221.132H307.432V225.543H316.837V221.132Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M335.597 221.132H326.191V225.543H335.597V221.132Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M354.356 221.132H344.951V225.543H354.356V221.132Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M316.837 232.041H307.432V236.453H316.837V232.041Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M335.597 232.041H326.191V236.453H335.597V232.041Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M354.356 232.041H344.951V236.453H354.356V232.041Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M316.837 242.963H307.432V247.375H316.837V242.963Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M335.597 242.963H326.191V247.375H335.597V242.963Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M354.356 242.963H344.951V247.375H354.356V242.963Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M316.837 253.873H307.432V258.285H316.837V253.873Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M335.597 253.873H326.191V258.285H335.597V253.873Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M354.356 253.873H344.951V258.285H354.356V253.873Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M316.837 264.795H307.432V269.207H316.837V264.795Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M335.597 264.795H326.191V269.207H335.597V264.795Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M354.356 264.795H344.951V269.207H354.356V264.795Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M316.837 275.705H307.432V280.117H316.837V275.705Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M335.597 275.705H326.191V280.117H335.597V275.705Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M354.356 275.705H344.951V280.117H354.356V275.705Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M316.837 286.615H307.432V291.026H316.837V286.615Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M335.597 286.615H326.191V291.026H335.597V286.615Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M354.356 286.615H344.951V291.026H354.356V286.615Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M316.837 297.537H307.432V301.949H316.837V297.537Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M335.597 297.537H326.191V301.949H335.597V297.537Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M354.356 297.537H344.951V301.949H354.356V297.537Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M316.837 307.308H307.432V311.72H316.837V307.308Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M335.597 307.308H326.191V311.72H335.597V307.308Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M354.356 307.308H344.951V311.72H354.356V307.308Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M316.837 318.231H307.432V322.643H316.837V318.231Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M335.597 318.231H326.191V322.643H335.597V318.231Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M354.356 318.231H344.951V322.643H354.356V318.231Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M357.799 185.04H301.822V125.043L357.799 150.415V185.04Z",
    fill: "#E6E6E6",
    fillOpacity: 0.3
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M448.035 209.312H383.07V363.538H448.035V209.312Z",
    fill: "#E6E6E6",
    fillOpacity: 0.3
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M412.36 204.028H387.848V224.949H412.36V204.028Z",
    fill: "#E6E6E6",
    fillOpacity: 0.3
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M396.62 202.485H390.047V221.271H396.62V202.485Z",
    fill: "#E6E6E6",
    fillOpacity: 0.3
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M410.3 202.485H403.727V221.271H410.3V202.485Z",
    fill: "#E6E6E6",
    fillOpacity: 0.3
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M443.875 204.104H429.287V218.692H443.875V204.104Z",
    fill: "#E6E6E6",
    fillOpacity: 0.3
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M402.005 222.421H392.6V226.833H402.005V222.421Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M420.765 222.421H411.359V226.833H420.765V222.421Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M439.538 222.421H430.133V226.833H439.538V222.421Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M402.005 233.343H392.6V237.755H402.005V233.343Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M420.765 233.343H411.359V237.755H420.765V233.343Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M439.538 233.343H430.133V237.755H439.538V233.343Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M402.005 244.253H392.6V248.665H402.005V244.253Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M420.765 244.253H411.359V248.665H420.765V244.253Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M439.538 244.253H430.133V248.665H439.538V244.253Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M402.005 255.175H392.6V259.587H402.005V255.175Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M420.765 255.175H411.359V259.587H420.765V255.175Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M439.538 255.175H430.133V259.587H439.538V255.175Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M402.005 266.085H392.6V270.497H402.005V266.085Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M420.765 266.085H411.359V270.497H420.765V266.085Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M439.538 266.085H430.133V270.497H439.538V266.085Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M402.005 276.994H392.6V281.406H402.005V276.994Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M420.765 276.994H411.359V281.406H420.765V276.994Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M439.538 276.994H430.133V281.406H439.538V276.994Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M402.005 287.917H392.6V292.328H402.005V287.917Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M420.765 287.917H411.359V292.328H420.765V287.917Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M439.538 287.917H430.133V292.328H439.538V287.917Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M402.005 298.826H392.6V303.238H402.005V298.826Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M420.765 298.826H411.359V303.238H420.765V298.826Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M439.538 298.826H430.133V303.238H439.538V298.826Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M402.005 309.749H392.6V314.16H402.005V309.749Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M420.765 309.749H411.359V314.16H420.765V309.749Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M439.538 309.749H430.133V314.16H439.538V309.749Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M402.005 320.658H392.6V325.07H402.005V320.658Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M420.765 320.658H411.359V325.07H420.765V320.658Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M439.538 320.658H430.133V325.07H439.538V320.658Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M402.005 331.568H392.6V335.98H402.005V331.568Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M420.765 331.568H411.359V335.98H420.765V331.568Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M439.538 331.568H430.133V335.98H439.538V331.568Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M402.005 342.49H392.6V346.902H402.005V342.49Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M420.765 342.49H411.359V346.902H420.765V342.49Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M439.538 342.49H430.133V346.902H439.538V342.49Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M196.533 209.312H131.568V363.538H196.533V209.312Z",
    fill: "#E6E6E6",
    fillOpacity: 0.3
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M160.856 204.028H136.344V224.95H160.856V204.028Z",
    fill: "#E6E6E6",
    fillOpacity: 0.3
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M145.132 202.486H138.559V221.271H145.132V202.486Z",
    fill: "#E6E6E6",
    fillOpacity: 0.3
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M158.808 202.486H152.234V221.271H158.808V202.486Z",
    fill: "#E6E6E6",
    fillOpacity: 0.3
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M192.373 204.104H177.785V218.692H192.373V204.104Z",
    fill: "#E6E6E6",
    fillOpacity: 0.3
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M150.517 222.421H141.111V226.833H150.517V222.421Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M169.276 222.421H159.871V226.833H169.276V222.421Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M188.036 222.421H178.631V226.833H188.036V222.421Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M150.517 233.344H141.111V237.755H150.517V233.344Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M169.276 233.344H159.871V237.755H169.276V233.344Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M188.036 233.344H178.631V237.755H188.036V233.344Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M150.517 244.253H141.111V248.665H150.517V244.253Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M169.276 244.253H159.871V248.665H169.276V244.253Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M188.036 244.253H178.631V248.665H188.036V244.253Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M150.517 255.176H141.111V259.587H150.517V255.176Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M169.276 255.176H159.871V259.587H169.276V255.176Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M188.036 255.176H178.631V259.587H188.036V255.176Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M150.517 266.085H141.111V270.497H150.517V266.085Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M169.276 266.085H159.871V270.497H169.276V266.085Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M188.036 266.085H178.631V270.497H188.036V266.085Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M150.517 276.995H141.111V281.407H150.517V276.995Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M169.276 276.995H159.871V281.407H169.276V276.995Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M188.036 276.995H178.631V281.407H188.036V276.995Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M150.517 287.917H141.111V292.329H150.517V287.917Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M169.276 287.917H159.871V292.329H169.276V287.917Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M188.036 287.917H178.631V292.329H188.036V287.917Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M150.517 298.827H141.111V303.239H150.517V298.827Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M169.276 298.827H159.871V303.239H169.276V298.827Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M188.036 298.827H178.631V303.239H188.036V298.827Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M150.517 309.749H141.111V314.161H150.517V309.749Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M169.276 309.749H159.871V314.161H169.276V309.749Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M188.036 309.749H178.631V314.161H188.036V309.749Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M150.517 320.658H141.111V325.07H150.517V320.658Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M169.276 320.658H159.871V325.07H169.276V320.658Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M188.036 320.658H178.631V325.07H188.036V320.658Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M150.517 331.568H141.111V335.98H150.517V331.568Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M169.276 331.568H159.871V335.98H169.276V331.568Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M188.036 331.568H178.631V335.98H188.036V331.568Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M150.517 342.49H141.111V346.902H150.517V342.49Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M169.276 342.49H159.871V346.902H169.276V342.49Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M188.036 342.49H178.631V346.902H188.036V342.49Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M568.433 189.136H467.326V363.526H568.433V189.136Z",
    fill: "#E6E6E6",
    fillOpacity: 0.3
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M487.032 203.851H477.627V208.262H487.032V203.851Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M505.792 203.851H496.387V208.262H505.792V203.851Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M524.552 203.851H515.146V208.262H524.552V203.851Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M487.032 214.76H477.627V219.172H487.032V214.76Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M505.792 214.76H496.387V219.172H505.792V214.76Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M524.552 214.76H515.146V219.172H524.552V214.76Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M487.032 225.683H477.627V230.095H487.032V225.683Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M505.792 225.683H496.387V230.095H505.792V225.683Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M524.552 225.683H515.146V230.095H524.552V225.683Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M487.032 236.592H477.627V241.004H487.032V236.592Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M505.792 236.592H496.387V241.004H505.792V236.592Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M524.552 236.592H515.146V241.004H524.552V236.592Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M487.032 247.502H477.627V251.914H487.032V247.502Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M505.792 247.502H496.387V251.914H505.792V247.502Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M524.552 247.502H515.146V251.914H524.552V247.502Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M487.032 258.424H477.627V262.836H487.032V258.424Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M505.792 258.424H496.387V262.836H505.792V258.424Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M524.552 258.424H515.146V262.836H524.552V258.424Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M487.032 269.334H477.627V273.746H487.032V269.334Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M505.792 269.334H496.387V273.746H505.792V269.334Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M524.552 269.334H515.146V273.746H524.552V269.334Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M487.032 280.256H477.627V284.668H487.032V280.256Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M505.792 280.256H496.387V284.668H505.792V280.256Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M524.552 280.256H515.146V284.668H524.552V280.256Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M487.032 291.166H477.627V295.577H487.032V291.166Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M505.792 291.166H496.387V295.577H505.792V291.166Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M524.552 291.166H515.146V295.577H524.552V291.166Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M487.032 302.075H477.627V306.487H487.032V302.075Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M505.792 302.075H496.387V306.487H505.792V302.075Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M524.552 302.075H515.146V306.487H524.552V302.075Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M487.032 312.997H477.627V317.409H487.032V312.997Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M505.792 312.997H496.387V317.409H505.792V312.997Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M524.552 312.997H515.146V317.409H524.552V312.997Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M487.032 323.907H477.627V328.319H487.032V323.907Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M505.792 323.907H496.387V328.319H505.792V323.907Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M524.552 323.907H515.146V328.319H524.552V323.907Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M542.454 203.851H533.049V208.262H542.454V203.851Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M561.214 203.851H551.809V208.262H561.214V203.851Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M542.454 214.76H533.049V219.172H542.454V214.76Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M561.214 214.76H551.809V219.172H561.214V214.76Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M542.454 225.683H533.049V230.095H542.454V225.683Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M561.214 225.683H551.809V230.095H561.214V225.683Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M542.454 236.592H533.049V241.004H542.454V236.592Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M561.214 236.592H551.809V241.004H561.214V236.592Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M542.454 247.502H533.049V251.914H542.454V247.502Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M561.214 247.502H551.809V251.914H561.214V247.502Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M542.454 258.424H533.049V262.836H542.454V258.424Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M561.214 258.424H551.809V262.836H561.214V258.424Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M542.454 269.334H533.049V273.746H542.454V269.334Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M561.214 269.334H551.809V273.746H561.214V269.334Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M542.454 280.256H533.049V284.668H542.454V280.256Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M561.214 280.256H551.809V284.668H561.214V280.256Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M542.454 291.166H533.049V295.577H542.454V291.166Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M561.214 291.166H551.809V295.577H561.214V291.166Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M542.454 302.075H533.049V306.487H542.454V302.075Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M561.214 302.075H551.809V306.487H561.214V302.075Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M542.454 312.997H533.049V317.409H542.454V312.997Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M561.214 312.997H551.809V317.409H561.214V312.997Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M542.454 323.907H533.049V328.319H542.454V323.907Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M561.214 323.907H551.809V328.319H561.214V323.907Z",
    fill: "#F5F5F5",
    fillOpacity: 0.26
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22796_4854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.963 151.423C256.775 151.167 260.766 150.987 264.886 150.911C266.497 150.911 268.058 150.885 269.619 150.859C276.501 147.709 281.695 149.784 283.179 150.526C288.833 146.147 291.98 136.746 293.618 127.935C292.21 124.631 291.545 121.327 291.366 117.511C291.033 117.46 290.701 117.383 290.343 117.229C287.784 116.102 285.277 113.566 284.151 109.904C283.179 106.728 284.253 103.142 286.582 101.451C281.823 95.3039 286.044 86.2624 289.038 81.6776C290.752 79.065 303.391 67.7439 315.749 68.0512C315.749 68.0512 294.641 66.54 286.147 77.7587C277.652 89.003 279.188 96.5334 271.512 99.6838C264.809 102.424 263.427 111.184 264.348 116.153C265.5 122.352 261.79 125.502 256.161 126.399C249.381 127.5 246.311 133.391 246.311 137.899C246.311 141.895 244.264 145.839 238.507 146.249C233.851 146.582 226.124 151.653 225.766 161.054C225.357 172.426 215.225 174.219 221.237 190.176C221.851 191.815 222.696 193.275 223.617 194.658C226.482 186.027 229.015 178.24 230.832 172.605C232.137 161.463 241.168 152.243 252.963 151.423Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.231 117.152C340.514 122.096 339.286 126.783 337.751 130.753C333.069 142.817 320.942 147.581 310.145 144.046C309.633 145.173 309.198 146.3 308.891 147.453C308.328 149.425 308.2 150.706 308.533 152.345C308.559 152.345 308.584 152.345 308.61 152.345C309.045 152.345 312.882 152.448 316.797 153.523C318.46 153.78 320.123 154.061 321.786 154.343C324.933 154.881 327.722 155.752 330.204 156.93C334.22 158.8 339.389 161.31 344.966 164.051C345.555 160.439 344.71 157.032 342.97 155.342C337.649 150.142 339.491 148.631 342.254 143.688C345.043 138.719 346.629 135.799 344.685 132.341C342.766 128.858 341.103 126.578 345.529 121.199C346.655 119.842 347.269 117.716 347.576 115.308H346.527V103.5H347.397C347.064 100.555 346.68 98.4545 346.68 98.4545L346.629 98.4033C346.911 107.266 342.766 114.693 341.231 117.152Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.472 124.145H383.446L391.915 170.249C393.015 176.345 394.115 182.466 395.036 188.434C389.331 185.899 383.574 183.081 377.792 180.315C369.579 176.319 356.403 169.685 344.941 164.025C344.608 166.048 343.815 168.097 342.459 169.967C344.403 174.577 345.478 180.136 345.785 186.667C347.269 191.405 349.265 196.912 351.695 201.215C352.156 202.035 352.591 202.855 352.974 203.674C353.844 204.084 354.714 204.494 355.635 204.878C357.989 205.928 360.42 206.978 362.799 208.003C363.49 208.31 364.181 208.592 364.846 208.874C371.319 211.64 377.894 214.278 384.7 216.763C388.128 217.992 391.608 219.196 395.369 220.323C397.288 220.861 399.207 221.424 401.535 221.937L403.351 222.295L405.603 222.628C405.91 222.705 406.678 222.731 407.189 222.756L408.878 222.808H409.21C409.594 222.782 409.978 222.756 410.362 222.731C411.129 222.654 411.897 222.5 412.716 222.295C414.302 221.885 415.965 221.143 417.244 220.246C419.905 218.479 421.287 216.404 422.054 215.047C422.31 214.637 422.464 214.304 422.591 214.022L423.026 213.049C423.206 212.588 423.41 211.947 423.538 211.563C423.666 211.128 423.794 210.667 423.871 210.308C423.948 209.924 424.024 209.565 424.075 209.284C424.28 207.977 424.306 207.081 424.357 206.21C424.382 204.52 424.28 203.264 424.178 202.035C423.947 199.679 423.589 197.681 423.231 195.734C422.489 191.867 421.594 188.306 420.596 184.797C418.703 177.779 416.579 171.017 414.276 164.358C409.748 150.962 403.966 132.213 398.388 119.252C394.064 123.018 389.229 125.144 383.472 124.145Z",
    fill: "#F38F19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.203 156.904C335.934 159.594 339.951 163.974 342.484 169.967C343.84 168.097 344.633 166.048 344.966 164.025C339.388 161.31 334.22 158.774 330.203 156.904Z",
    fill: "#F38F19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.811 186.693C345.836 187.231 345.887 187.743 345.887 188.306C346.015 192.994 346.911 197.322 347.985 201.369C349.648 202.163 351.311 202.957 353 203.7C352.616 202.88 352.156 202.061 351.721 201.241C349.265 196.938 347.269 191.431 345.811 186.693Z",
    fill: "#F38F19"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M345.811 186.693C345.836 187.231 345.887 187.743 345.887 188.306C346.015 192.994 346.911 197.322 347.985 201.369C349.648 202.163 351.311 202.957 353 203.7C352.616 202.88 352.156 202.061 351.721 201.241C349.265 196.938 347.269 191.431 345.811 186.693Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.597 113.464C373.699 111.697 374.876 109.315 376.181 107.65C375.899 107.368 375.669 107.035 375.464 106.702C375.464 106.702 375.209 106.113 375.004 105.319H351.363V113.464H373.597Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.698 105.319C397.928 107.317 396.572 109.571 394.884 109.98C392.965 110.442 384.752 111.389 379.456 109.571C378.893 111.312 378.049 112.952 378.049 112.952L395.242 113.464H405.63V105.319H397.698Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.75 114.642C374.748 117.357 383.446 124.145 383.446 124.145C383.446 124.145 383.447 124.145 383.472 124.145L398.439 119.278C398.516 113.771 395.216 113.438 395.216 113.438H373.596C373.571 113.899 373.622 114.309 373.75 114.642Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.44 119.304L383.473 124.17C389.229 125.144 394.065 123.018 398.44 119.304Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.429 109.571C378.124 109.11 376.973 108.495 376.154 107.65C374.85 109.315 373.673 111.697 373.57 113.464H395.19L377.997 112.952C378.022 112.952 378.866 111.287 379.429 109.571Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.932 102.732C392.581 100.965 378.458 100.299 376.027 101.426C374.518 102.143 374.671 103.987 375.004 105.319H397.698C397.57 104.294 397.084 103.321 395.932 102.732Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.181 107.65C377.127 106.446 378.151 105.601 378.893 105.652C380.351 105.754 380.07 107.701 379.456 109.571C384.752 111.364 392.965 110.442 394.884 109.98C396.572 109.571 397.928 107.317 397.698 105.319H375.004C375.209 106.113 375.464 106.702 375.464 106.702C375.644 107.035 375.899 107.368 376.181 107.65Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.866 105.652C378.124 105.6 377.101 106.446 376.154 107.649C376.973 108.495 378.099 109.109 379.429 109.57C380.043 107.701 380.325 105.754 378.866 105.652Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.629 100.375V105.319H428.118V113.464H405.629V118.407H435.743V100.375H405.629Z",
    fill: "#EAA553"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.144 105.319H405.629V113.464H428.144V105.319Z",
    fill: "#EAA553"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.742 97.3787V100.375H452.628V118.407H435.742V121.378H501.214V97.3787H435.742Z",
    fill: "#F38F19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.628 100.375H435.742V118.407H452.628V100.375Z",
    fill: "#F38F19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.215 94.7661V97.3787H504.797V121.378H501.215V125.169H505.999V94.7661H501.215Z",
    fill: "#C48030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.797 97.3787H501.215V121.404H504.797V97.3787Z",
    fill: "#C48030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.601 115.282H351.337V113.438V105.293V103.449H347.396C347.806 106.881 348.087 111.44 347.601 115.282Z",
    fill: "#F38F19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.553 115.282H347.602C348.088 111.44 347.806 106.881 347.423 103.475H346.553V115.282Z",
    fill: "#F38F19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.443 327.823C291.29 341.398 290.906 363.861 289.908 391.728L295.563 351.131C295.563 351.131 298.863 386.785 298.658 425H355.048C352.848 376.744 349.803 337.863 348.345 320.472C342.895 325.415 318.819 328.54 291.443 327.823Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.601 425H298.684C298.889 386.785 295.588 351.131 295.588 351.131L289.934 391.728C289.627 400.257 289.269 409.299 288.859 418.75C289.09 420.799 289.345 422.9 289.601 425Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M289.601 425H298.684C298.889 386.785 295.588 351.131 295.588 351.131L289.934 391.728C289.627 400.257 289.269 409.299 288.859 418.75C289.09 420.799 289.345 422.9 289.601 425Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.833 418.776C288.398 415.088 287.989 411.476 287.656 407.993C287.017 401.871 286.505 396.134 286.121 390.729C283.895 359.763 285.174 339.912 287.068 327.695C268.57 326.952 248.997 324.39 232.904 319.473C229.322 328.796 223.591 350.234 222.67 393.162C222.465 402.691 222.517 413.269 222.849 425H288.526C288.654 422.9 288.756 420.825 288.833 418.776Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.122 390.729C286.506 396.134 287.017 401.897 287.657 407.993L289.934 391.728C290.906 363.835 291.316 341.372 291.469 327.823C290.011 327.797 288.578 327.746 287.094 327.669C285.175 339.912 283.896 359.737 286.122 390.729Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.776 190.919L328.208 176.55C325.061 176.678 321.428 176.319 317.207 175.346C314.444 174.706 311.962 174.219 309.583 173.809C308.431 174.475 307.638 174.936 307.638 174.936C308.227 175.064 307.05 174.885 307.638 174.936C307.638 174.936 303.749 173.681 298.427 172.759C293.515 172.785 289.652 173.707 286.326 175.474C286.351 176.191 286.556 176.703 286.556 176.703L285.891 175.679C280.543 178.727 276.578 184.055 271.665 191.687C267.623 197.937 261.636 202.01 255.189 204.007C253.551 208.464 251.658 213.536 249.611 218.889L237.74 267.016C237.458 274.931 236.921 282.256 236.153 288.993C236.102 289.223 236.051 289.505 236.051 289.71C235.386 294.986 234.644 299.853 233.723 304.31C233.441 305.667 233.134 306.999 232.802 308.305C232.162 311.097 231.113 315.912 230.371 318.679C231.215 318.96 232.06 319.217 232.93 319.473C234.618 315.093 235.821 313.377 235.821 313.377L290.394 313.582C291.187 311.353 291.75 310.406 291.75 310.406L347.5 310.636C347.5 310.636 347.832 314.12 348.37 320.472C349.137 319.78 349.572 319.089 349.572 318.32C349.572 289.608 339.415 257.309 342.127 238.611C358.655 227.034 351.926 216.097 347.986 201.344C346.451 200.626 344.941 199.935 343.406 199.218C337.828 196.58 332.302 193.813 326.776 190.919Z",
    fill: "#F38F19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.376 175.474C289.676 173.681 293.565 172.784 298.478 172.759C296.661 172.452 294.691 172.17 292.644 171.99C287.067 171.478 286.299 173.911 286.376 175.474Z",
    fill: "#F38F19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.584 152.448C308.712 152.985 308.865 153.574 309.07 154.24C308.814 153.293 308.635 152.652 308.584 152.448Z",
    fill: "#F38F19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.618 150.859C268.058 150.885 266.497 150.911 264.885 150.911C260.766 150.987 256.775 151.167 252.963 151.423C241.193 152.268 232.136 161.463 230.908 172.631C232.699 167.098 233.799 163.64 233.799 163.64L261.38 186.846C261.38 186.846 258.949 193.839 255.188 204.033C261.661 202.035 267.623 197.962 271.665 191.713C276.603 184.106 280.569 178.752 285.891 175.704L269.618 150.859Z",
    fill: "#F38F19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.786 154.343C320.148 154.061 318.46 153.805 316.797 153.523C320.097 154.446 323.423 156.034 324.728 158.902C327.696 165.331 322.86 174.245 322.86 174.245C322.86 174.245 323.551 169.993 320.814 169.327C318.818 168.84 312.754 172.042 309.607 173.809C311.961 174.219 314.469 174.706 317.232 175.346C321.453 176.319 325.086 176.678 328.233 176.55L330.203 156.93C327.722 155.752 324.933 154.881 321.786 154.343Z",
    fill: "#F38F19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.234 176.55L326.801 190.919C332.327 193.813 337.828 196.579 343.431 199.218L342.996 176.703C343.252 177.395 344.224 181.57 345.836 186.693C345.529 180.161 344.454 174.603 342.51 169.993C339.926 173.476 335.423 176.268 328.234 176.55Z",
    fill: "#F38F19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.204 156.904L328.234 176.524C335.424 176.242 339.952 173.476 342.485 169.967C339.952 163.974 335.935 159.619 330.204 156.904Z",
    fill: "#F38F19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.811 186.693C344.224 181.57 343.227 177.395 342.971 176.704L343.406 199.218C344.915 199.961 346.45 200.627 347.985 201.344C346.911 197.297 346.041 192.994 345.887 188.281C345.862 187.743 345.836 187.231 345.811 186.693Z",
    fill: "#F38F19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.751 310.406C291.751 310.406 291.188 311.353 290.395 313.582H291.546C291.546 313.582 291.546 318.679 291.444 327.823C318.82 328.54 342.895 325.415 348.37 320.472C347.833 314.119 347.5 310.636 347.5 310.636L291.751 310.406Z",
    fill: "#F38F19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.394 313.582L235.795 313.377C235.795 313.377 234.593 315.093 232.904 319.473C248.972 324.39 268.544 326.926 287.068 327.695C288.168 320.728 289.447 316.22 290.394 313.582Z",
    fill: "#F38F19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.443 327.823C291.546 318.679 291.546 313.582 291.546 313.582H290.394C289.448 316.22 288.168 320.702 287.094 327.669C288.552 327.746 289.985 327.797 291.443 327.823Z",
    fill: "#F38F19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.894 248.216C237.894 248.498 237.919 248.805 237.919 249.113C237.97 252.212 237.971 255.209 237.945 258.128C237.919 261.176 237.843 264.122 237.74 267.016L249.637 218.889C246.03 228.34 241.962 238.662 237.894 248.216Z",
    fill: "#F38F19"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M237.894 248.216C237.894 248.498 237.919 248.805 237.919 249.113C237.97 252.212 237.971 255.209 237.945 258.128C237.919 261.176 237.843 264.122 237.74 267.016L249.637 218.889C246.03 228.34 241.962 238.662 237.894 248.216Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.56 237.433C237.381 232.899 237.1 228.238 236.716 223.474C236.332 218.556 235.872 213.561 235.283 208.413V208.387C235.104 206.748 234.848 205.058 234.643 203.393C230.217 201.625 226.379 198.705 223.693 194.684C215.096 220.656 203.583 254.133 200.027 258.538C191.021 269.68 143.1 298.982 137.65 302.286C138.571 302.542 139.16 302.722 139.16 302.722C143.97 306.359 145.94 314.529 139.313 320.677C139.313 320.677 201.946 306.538 222.567 278.671C226.738 273.036 232.29 261.381 237.893 248.216C237.867 246.423 237.842 244.63 237.79 242.786C237.739 241.019 237.662 239.251 237.56 237.433Z",
    fill: "#F38F19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.644 203.393C233.672 195.606 232.546 187.666 231.113 179.47C230.704 177.139 230.653 174.859 230.908 172.631C229.092 178.24 226.559 186.027 223.693 194.684C226.38 198.705 230.218 201.625 234.644 203.393Z",
    fill: "#F38F19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.645 203.393C234.849 205.057 235.105 206.748 235.284 208.387V208.413C235.873 213.561 236.333 218.556 236.717 223.474C237.101 228.238 237.382 232.899 237.561 237.433C237.664 239.251 237.74 241.019 237.791 242.786L249.663 218.786L249.637 218.889C251.684 213.51 253.577 208.464 255.215 204.007C248.333 206.133 240.913 205.903 234.645 203.393Z",
    fill: "#F38F19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.799 163.641C233.799 163.641 232.699 167.098 230.908 172.631C230.652 174.859 230.704 177.139 231.113 179.47C232.546 187.666 233.672 195.606 234.644 203.393C240.912 205.903 248.332 206.133 255.214 204.007C258.95 193.813 261.406 186.821 261.406 186.821L233.799 163.641Z",
    fill: "#F38F19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.662 218.786L237.791 242.786C237.868 244.63 237.868 246.423 237.893 248.216C241.961 238.662 246.029 228.34 249.637 218.889L249.662 218.786Z",
    fill: "#F38F19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.762 81.4984C335.5 84.0597 337.547 87.2614 338.979 90.8473L346.629 98.3777C346.501 94.0234 345.35 89.3361 342.254 84.7257C338.442 79.0139 333.786 76.1964 329.359 74.8901C330.613 76.3757 331.816 78.1174 332.916 80.2177C332.941 80.2177 332.916 80.73 332.762 81.4984Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.257 99.274C342.332 99.7607 343.458 100.555 344.507 101.835C344.814 102.22 344.737 102.757 344.379 103.065C344.2 103.218 343.969 103.27 343.765 103.244C343.534 103.218 343.33 103.116 343.176 102.911C342.665 102.271 342.102 101.81 341.564 101.426C341.743 102.937 341.871 104.474 341.897 106.036L342.281 105.985C342.281 105.985 342.153 106.138 341.923 106.343C341.999 109.98 341.743 113.618 341.232 117.152C342.792 114.693 346.912 107.265 346.656 98.4031L339.006 90.8728C340.029 93.4854 340.797 96.3285 341.257 99.274Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.666 150.808C291.904 150.911 299.707 151.269 307.818 152.242C308.048 152.268 308.304 152.294 308.56 152.345C308.227 150.706 308.33 149.425 308.918 147.453C304.799 145.122 302.368 141.152 301.191 138.719C299.887 137.515 298.633 136.183 297.482 134.62C295.819 132.315 294.565 130.138 293.644 127.961C292.006 136.746 288.859 146.172 283.205 150.552C283.487 150.706 283.666 150.808 283.666 150.808C283.666 150.783 283.64 150.783 283.666 150.808Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.664 174.936C308.252 175.039 307.076 174.885 307.664 174.936Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.051 173.271C307.074 174.321 307.663 174.936 307.663 174.936C307.944 174.501 308.174 174.065 308.405 173.604C307.586 173.476 306.818 173.374 306.051 173.271Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.664 150.808C290.751 157.673 301.906 169.045 306.051 173.271C306.819 173.374 307.586 173.476 308.405 173.604C311.68 167.047 310.017 158.082 309.07 154.24C308.865 153.574 308.686 152.985 308.584 152.447C308.558 152.396 308.558 152.345 308.558 152.345C308.328 152.319 308.072 152.294 307.816 152.242C299.732 151.244 291.902 150.885 283.664 150.808Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.893 147.427C309.2 146.3 309.635 145.148 310.146 144.021C309.635 145.173 309.2 146.3 308.893 147.427Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.144 144.046C306.946 142.996 303.902 141.229 301.164 138.719C302.341 141.152 304.772 145.122 308.891 147.453C309.198 146.3 309.633 145.173 310.144 144.046Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.326 136.362L312.012 140.358C311.373 141.51 310.733 142.689 310.221 143.867C310.196 143.918 310.17 143.969 310.144 144.046C320.941 147.555 333.069 142.817 337.751 130.753C339.286 126.808 340.514 122.095 341.23 117.152C340.872 117.716 340.642 118.023 340.642 118.023L323.346 90.4116C322.451 90.5909 321.504 90.7446 320.43 90.7702C311.475 91.1544 309.53 101.22 303.876 105.319C303.211 108.392 301.369 111.568 296.303 110.236C296.738 114.411 294.64 118.125 291.391 117.536C291.595 121.353 292.235 124.657 293.642 127.961C294.307 124.426 294.717 120.994 294.947 118.049L309.326 136.362ZM322.758 127.884C318.127 125.348 319.432 118.484 319.432 118.484C321.376 122.326 330.178 126.322 330.178 126.322C330.178 126.322 327.389 130.42 322.758 127.884ZM331.482 108.572C331.482 108.572 333.453 112.798 335.73 116.563C336.472 117.792 335.909 119.38 334.553 119.816C332.224 120.584 329.794 120.712 329.794 120.712L331.482 108.572ZM325.163 104.806C325.496 105.344 325.675 106.113 325.547 106.932C325.342 108.392 324.395 109.468 323.449 109.34C322.502 109.212 321.888 107.906 322.093 106.446C322.272 105.191 322.988 104.268 323.807 104.115C323.781 104.089 323.781 104.089 323.756 104.064L327.414 103.551C327.414 103.551 326.34 104.755 325.163 104.806ZM317.462 99.1458C320.762 95.6624 324.702 96.3283 324.856 96.3539C325.316 96.4308 325.649 96.8918 325.547 97.3529C325.47 97.8139 325.009 98.1213 324.549 98.0444C324.523 98.0444 321.376 97.5065 318.715 100.324C318.536 100.503 318.306 100.606 318.076 100.606C317.871 100.606 317.641 100.529 317.487 100.375C317.155 100.042 317.129 99.4788 317.462 99.1458Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.979 90.8472C337.546 87.2613 335.5 84.0596 332.762 81.4983C332.634 82.1642 332.404 83.0095 331.969 83.9572L338.979 90.8472Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.348 90.4117L340.643 118.023C340.643 118.023 340.873 117.69 341.232 117.152C341.743 113.617 341.999 109.955 341.922 106.343C341.513 106.702 340.797 107.214 340.055 107.24C340.387 107.778 340.566 108.546 340.438 109.366C340.234 110.826 339.287 111.901 338.341 111.773C337.394 111.645 336.78 110.339 336.984 108.879C337.164 107.624 337.88 106.702 338.699 106.548C338.673 106.523 338.673 106.523 338.648 106.497L341.922 106.036C341.871 104.499 341.743 102.962 341.59 101.425C339.62 100.042 337.675 100.17 337.547 100.196C337.061 100.247 336.652 99.8886 336.601 99.4276C336.55 98.9409 336.908 98.5311 337.368 98.4799C337.471 98.4799 339.236 98.3262 341.283 99.2995C340.822 96.354 340.055 93.5365 339.006 90.8983L331.995 84.0083C330.87 86.4416 328.49 89.3871 323.348 90.4117Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.165 138.693C300.551 137.412 300.269 136.567 300.269 136.567L309.326 136.362L294.947 118.023C294.717 120.968 294.308 124.401 293.643 127.935C294.564 130.112 295.817 132.29 297.48 134.595C298.606 136.157 299.86 137.489 301.165 138.693Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.145 144.046C310.17 143.995 310.196 143.944 310.221 143.867C310.196 143.918 310.17 143.995 310.145 144.046Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.222 143.867C310.759 142.689 311.373 141.511 312.013 140.358L309.327 136.362L300.27 136.567C300.27 136.567 300.551 137.438 301.165 138.693C303.903 141.203 306.947 142.996 310.145 144.021C310.171 143.995 310.197 143.918 310.222 143.867Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.459 106.599C295.868 107.829 296.175 109.084 296.278 110.211C301.344 111.543 303.186 108.367 303.851 105.293C301.753 106.83 299.143 107.573 295.459 106.599Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.385 74.8901C325.342 70.0748 320.609 68.1794 315.799 68.0769L321.735 73.9168C324.037 73.8399 326.673 74.0961 329.385 74.8901Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.089 81.7033C286.096 86.3137 281.874 95.3296 286.633 101.477C287.375 100.939 288.245 100.606 289.217 100.529C289.575 100.504 289.908 100.58 290.266 100.632C290.471 99.3253 290.803 98.4289 290.803 98.4289L292.313 98.6594C292.313 98.5569 292.338 98.4545 292.338 98.352C293.336 85.8014 302.854 76.6062 313.907 75.2743C313.907 75.2743 317.182 74.0193 321.761 73.8912L315.826 68.0513C303.442 67.7696 290.803 79.0651 289.089 81.7033Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.734 73.9168L324.344 76.5037C325.879 77.0416 327.389 77.6819 328.898 78.5528C330.331 79.398 331.585 80.4226 332.762 81.524C332.915 80.7556 332.941 80.2433 332.941 80.2433C331.84 78.143 330.638 76.4013 329.384 74.9157C326.672 74.0961 324.037 73.8399 321.734 73.9168Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.371 76.4781L321.761 73.8911C317.181 74.0192 313.906 75.2742 313.906 75.2742C317.309 74.89 320.865 75.2742 324.371 76.4781Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.852 105.319C309.506 101.221 311.451 91.1545 320.405 90.7703C321.48 90.7191 322.427 90.591 323.322 90.4117L313.856 75.2998C302.803 76.6317 293.285 85.8269 292.287 98.3775C292.287 98.48 292.262 98.5824 292.262 98.6849L304.133 100.529C304.159 100.503 304.389 102.885 303.852 105.319Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.763 81.4983C331.586 80.3969 330.333 79.3723 328.9 78.5271C327.416 77.6562 325.881 76.9903 324.346 76.478L331.944 83.9571C332.379 83.0351 332.635 82.1642 332.763 81.4983Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.97 83.9573L324.371 76.4782C320.866 75.2487 317.309 74.8645 313.881 75.3L323.347 90.4119C328.49 89.3874 330.869 86.4418 331.97 83.9573Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.287 98.6592L290.778 98.4287C290.778 98.4287 290.445 99.3252 290.24 100.631C290.905 100.76 291.519 100.99 292.057 101.4C292.134 100.529 292.21 99.6069 292.287 98.6592Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.459 106.6C299.169 107.547 301.753 106.83 303.877 105.319C304.389 102.886 304.158 100.504 304.158 100.504L292.287 98.6594C292.21 99.6071 292.133 100.504 292.057 101.4C293.592 102.501 294.743 104.499 295.459 106.6Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.433 118.458C319.433 118.458 318.128 125.323 322.759 127.859C327.39 130.394 330.179 126.296 330.179 126.296C330.179 126.296 321.378 122.301 319.433 118.458Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.808 104.115C322.99 104.269 322.273 105.191 322.094 106.446C321.889 107.906 322.503 109.212 323.45 109.34C324.397 109.468 325.343 108.392 325.548 106.932C325.676 106.087 325.497 105.344 325.164 104.807C324.704 104.832 324.243 104.653 323.808 104.115Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.646 106.523C337.827 106.676 337.111 107.598 336.932 108.854C336.727 110.313 337.341 111.62 338.288 111.748C339.235 111.876 340.181 110.8 340.386 109.34C340.514 108.495 340.335 107.752 340.002 107.214C339.542 107.24 339.081 107.061 338.646 106.523Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.897 106.343C342.127 106.139 342.255 105.985 342.255 105.985L341.871 106.036C341.897 106.113 341.897 106.215 341.897 106.343Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.647 106.523C338.775 106.497 338.903 106.446 339.031 106.472C339.44 106.523 339.773 106.83 340.003 107.214C340.745 107.189 341.461 106.702 341.871 106.318C341.871 106.215 341.871 106.113 341.871 106.01L338.596 106.472C338.621 106.497 338.647 106.523 338.647 106.523Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.056 106.471C338.928 106.446 338.8 106.497 338.672 106.523C339.081 107.06 339.567 107.24 340.028 107.214C339.772 106.83 339.465 106.523 339.056 106.471Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.731 116.563C333.479 112.824 331.484 108.572 331.484 108.572L329.795 120.738C329.795 120.738 332.226 120.584 334.554 119.842C335.91 119.381 336.473 117.767 335.731 116.563Z",
    fill: "#ED847E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.314 117.101C289.958 117.101 288.858 116 288.858 114.642C288.858 113.285 289.958 112.183 291.314 112.183C291.339 112.183 291.339 112.183 291.365 112.183C291.416 110.672 291.493 109.084 291.621 107.368C290.956 106.497 290.546 105.549 290.342 104.602C288.73 103.705 287.527 102.629 286.632 101.477C284.278 103.142 283.229 106.728 284.201 109.929C285.327 113.592 287.834 116.153 290.393 117.255C290.751 117.408 291.084 117.46 291.416 117.536C291.416 117.383 291.391 117.255 291.391 117.101C291.339 117.075 291.314 117.101 291.314 117.101Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.303 110.237C294.026 109.622 292.568 108.597 291.621 107.394C291.493 109.11 291.416 110.698 291.365 112.209C292.696 112.234 293.77 113.31 293.77 114.642C293.77 115.974 292.696 117.05 291.365 117.075C291.365 117.229 291.391 117.383 291.391 117.511C294.64 118.126 296.738 114.412 296.303 110.237Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.316 104.602C290.547 105.549 290.93 106.523 291.596 107.368C291.647 106.702 291.698 105.985 291.749 105.268C291.263 105.063 290.751 104.858 290.316 104.602Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.459 106.599C294.052 106.241 292.875 105.78 291.775 105.293C291.723 106.01 291.672 106.702 291.621 107.394C292.568 108.597 294.026 109.647 296.303 110.237C296.175 109.084 295.868 107.829 295.459 106.599Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.317 104.602C289.985 103.167 290.062 101.759 290.215 100.632C289.883 100.555 289.524 100.504 289.166 100.529C288.194 100.606 287.324 100.939 286.582 101.477C287.529 102.629 288.731 103.705 290.317 104.602Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.316 104.602C290.751 104.858 291.263 105.063 291.749 105.293C291.852 104.064 291.954 102.758 292.056 101.4C291.493 100.99 290.879 100.76 290.24 100.632C290.061 101.759 290.009 103.193 290.316 104.602Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.057 101.4C291.955 102.757 291.852 104.038 291.75 105.293C292.85 105.78 294.027 106.241 295.434 106.599C294.743 104.499 293.592 102.501 292.057 101.4Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.859 114.642C288.859 116 289.96 117.101 291.316 117.101C291.341 117.101 291.341 117.101 291.367 117.101C291.316 115.564 291.316 113.95 291.367 112.234C291.341 112.234 291.341 112.234 291.316 112.234C289.96 112.209 288.859 113.284 288.859 114.642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.367 117.076C292.697 117.05 293.772 115.974 293.772 114.642C293.772 113.31 292.697 112.235 291.367 112.209C291.316 113.925 291.29 115.564 291.367 117.076Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.103 100.606C318.333 100.606 318.564 100.504 318.743 100.324C321.404 97.5068 324.55 98.0447 324.576 98.0447C325.037 98.1215 325.497 97.8141 325.574 97.3531C325.651 96.8921 325.344 96.431 324.883 96.3542C324.73 96.3286 320.764 95.6626 317.489 99.146C317.156 99.5046 317.182 100.043 317.515 100.375C317.668 100.529 317.873 100.606 318.103 100.606Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.149 102.911C343.303 103.09 343.533 103.218 343.738 103.244C343.942 103.27 344.173 103.193 344.352 103.065C344.736 102.757 344.787 102.219 344.48 101.835C343.456 100.555 342.305 99.7606 341.23 99.2739C341.333 99.9911 341.435 100.708 341.512 101.425C342.1 101.81 342.638 102.271 343.149 102.911Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.343 98.4545C336.857 98.5058 336.524 98.9156 336.576 99.4022C336.627 99.8889 337.036 100.222 337.522 100.171C337.65 100.171 339.569 100.043 341.565 101.4C341.488 100.683 341.385 99.9657 341.283 99.2485C339.211 98.3008 337.471 98.4545 337.343 98.4545Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.807 104.115C323.935 104.089 324.063 104.038 324.191 104.064C324.6 104.115 324.933 104.422 325.163 104.832C326.314 104.807 327.415 103.577 327.415 103.577L323.756 104.089C323.781 104.089 323.807 104.089 323.807 104.115Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.192 104.038C324.064 104.013 323.937 104.064 323.809 104.089C324.218 104.627 324.704 104.807 325.165 104.781C324.934 104.397 324.602 104.115 324.192 104.038Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.795 150.808C282.923 150.706 283.051 150.629 283.179 150.527C281.695 149.784 276.502 147.709 269.619 150.859C272.024 150.834 274.404 150.783 276.732 150.783C278.804 150.757 280.8 150.783 282.795 150.808Z",
    fill: "#EAA553"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.607 176.704C286.607 176.704 286.402 176.166 286.376 175.474C286.223 175.551 286.069 175.602 285.941 175.705L286.607 176.704Z",
    fill: "#EAA553"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.453 172.733C303.775 173.655 307.664 174.911 307.664 174.911C307.664 174.911 306.768 174.193 305.515 173.169C302.931 172.887 300.602 172.733 298.453 172.733Z",
    fill: "#EAA553"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.515 173.194C302.649 170.889 297.839 166.945 296.79 165.792L296.765 165.767C289.371 157.75 281.439 151.654 281.439 151.654C281.9 151.397 282.361 151.09 282.795 150.783C280.8 150.757 278.804 150.757 276.732 150.757C274.404 150.757 272.024 150.783 269.619 150.834L285.917 175.679C286.07 175.602 286.224 175.525 286.352 175.448C286.301 173.886 287.043 171.453 292.595 171.939C294.641 172.119 296.611 172.4 298.428 172.708C300.603 172.733 302.931 172.887 305.515 173.194Z",
    fill: "#EAA553"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.665 150.808L283.639 150.783C283.639 150.783 283.486 150.68 283.179 150.527C283.051 150.629 282.923 150.706 282.795 150.808C283.076 150.808 283.383 150.808 283.665 150.808Z",
    fill: "#EAA553"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.514 173.194C306.767 174.219 307.663 174.936 307.663 174.936C307.663 174.936 307.049 174.321 306.051 173.271C305.872 173.246 305.693 173.22 305.514 173.194Z",
    fill: "#EAA553"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.665 150.808C283.384 150.808 283.077 150.808 282.795 150.808C282.361 151.115 281.9 151.423 281.439 151.679C281.439 151.679 289.396 157.749 296.765 165.792L296.79 165.818C297.865 166.97 302.675 170.915 305.515 173.22C305.694 173.245 305.873 173.271 306.052 173.297C301.933 169.045 290.778 157.673 283.665 150.808Z",
    fill: "#EAA553"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.797 153.523C312.882 152.448 309.044 152.345 308.609 152.345C309.121 152.422 309.633 152.473 310.17 152.55C312.37 152.832 314.596 153.165 316.797 153.523Z",
    fill: "#EAA553"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.664 174.936C307.664 174.936 308.432 174.475 309.609 173.809C309.225 173.732 308.815 173.655 308.457 173.604C307.997 174.424 307.664 174.936 307.664 174.936Z",
    fill: "#EAA553"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.815 169.327C323.552 169.993 322.862 174.245 322.862 174.245C322.862 174.245 327.697 165.331 324.729 158.902C323.425 156.059 320.098 154.446 316.798 153.523C314.598 153.165 312.372 152.832 310.171 152.55C309.634 152.473 309.122 152.422 308.611 152.345C308.585 152.345 308.56 152.345 308.534 152.345C308.534 152.371 308.56 152.422 308.56 152.448C308.636 152.653 308.815 153.267 309.046 154.241C309.378 155.291 309.839 156.495 310.427 158.083C310.504 158.364 310.632 158.646 310.811 158.928C313.625 163.359 310.095 170.659 308.432 173.63C308.815 173.681 309.199 173.758 309.583 173.835C312.756 172.042 318.819 168.815 320.815 169.327Z",
    fill: "#EAA553"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.406 173.604C308.176 174.065 307.945 174.501 307.664 174.936C307.664 174.936 307.997 174.424 308.457 173.604C308.432 173.604 308.432 173.604 308.406 173.604Z",
    fill: "#EAA553"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.584 152.448C308.584 152.422 308.559 152.371 308.559 152.345C308.559 152.345 308.559 152.396 308.584 152.448Z",
    fill: "#EAA553"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.406 173.604C308.432 173.604 308.432 173.604 308.457 173.604C310.12 170.633 313.626 163.333 310.837 158.902C310.658 158.62 310.53 158.339 310.453 158.057C309.865 156.469 309.404 155.265 309.071 154.215C310.018 158.082 311.681 167.047 308.406 173.604Z",
    fill: "#EAA553"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.651 302.286C135.501 301.697 131.561 300.621 129.387 300.186C127.8 299.853 125.421 301.134 123.502 302.773C124.628 303.003 125.549 303.413 125.549 303.413C131.357 306.897 129.463 322.008 128.747 324.826C128.568 325.543 128.056 326.209 127.391 326.747C127.391 326.747 131.817 325.825 136.192 323.007C137.42 322.265 138.444 321.471 139.339 320.651L137.139 302.619C137.139 302.619 137.318 302.491 137.651 302.286Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.16 302.722C139.16 302.722 138.572 302.542 137.651 302.286C137.318 302.491 137.113 302.593 137.113 302.593L139.314 320.651C145.94 314.529 143.97 306.359 139.16 302.722Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.483 307.281C120.253 306.205 121.634 304.335 123.502 302.773C122.12 302.491 120.457 302.491 119.741 303.951C118.436 306.589 118.897 322.162 120.79 325.876C122.197 328.642 125.498 328.284 127.391 326.747L127.058 306.615C127.058 306.615 121.148 310.303 120.483 307.281Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.746 324.826C129.462 322.008 131.356 306.896 125.548 303.413C125.548 303.413 124.627 303.003 123.501 302.773C121.633 304.335 120.252 306.205 120.482 307.281C121.147 310.303 127.057 306.615 127.057 306.615L127.39 326.747C128.055 326.235 128.567 325.569 128.746 324.826Z",
    fill: "#FFC3BD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22796_4854"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 387,
    height: 295,
    fill: "white",
    transform: "translate(119 68)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMloSearchLady);
export default __webpack_public_path__ + "static/media/MLOSearchLady.39d8f48c2fd69ffbd24cf1d23eea1a8a.svg";
export { ForwardRef as ReactComponent };